/** 備品マスタは人事アプリのものを使う。ここは案内だけ(画面を複製しない)。 */
import { Alert, Button, Space, Typography } from "antd";
import { Link } from "react-router-dom";

export function EquipmentLinkPage() {
  return (
    <div>
      <Typography.Title level={3}>備品マスタ</Typography.Title>
      <Alert
        type="info"
        showIcon
        message="備品マスタは人事アプリの台帳が本体"
        description={
          <Space direction="vertical" size={8}>
            <span>
              1行=1個体の台帳は人事(貸与品)側にあり、デバイス台帳の製造番号と一致した個体に端末が自動で紐づく。
              二重管理を避けるため、こちらには同じ画面を置かない。
            </span>
            <Link to="/hr/equipment">
              <Button type="primary">人事の備品マスタを開く</Button>
            </Link>
          </Space>
        }
      />
      <Typography.Paragraph type="secondary" style={{ fontSize: 12, marginTop: 16 }}>
        端末側の一覧は<Link to="/mdm/devices">デバイス台帳</Link>。
      </Typography.Paragraph>
    </div>
  );
}
